import { render, staticRenderFns } from "./AddStudentDocumentDialog.vue?vue&type=template&id=460b0576"
import script from "./AddStudentDocumentDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddStudentDocumentDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddStudentDocumentDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports